import { SlideOverDialog } from "@bluebottlecoffee/design-system/components";
import { FunctionComponent, useRef, useState } from "react";
import { AccountMenuCopy } from "../lib/account-menu";
import { Login, LoginCopy } from "./Login";

export interface DialogData {
  copy: LoginCopy;
  accountMenuCopy: AccountMenuCopy;
  region: string;
  lang: string;
}

export const LoginDialog: FunctionComponent<DialogData> = ({
  copy,
  accountMenuCopy,
  ...defaultProps
}) => {
  const [title, setTitle] = useState<string>(copy.title);
  const dismissButtonRef = useRef<HTMLButtonElement>(null);
  return (
    <SlideOverDialog
      dismissText={copy.dismissText}
      contentType="login"
      title={title}
      dismissButtonRef={dismissButtonRef}
    >
      <Login
        copy={copy}
        accountMenuCopy={accountMenuCopy}
        updateTitle={setTitle}
        focusDismissButton={() => dismissButtonRef.current?.focus()}
        {...defaultProps}
      />
    </SlideOverDialog>
  );
};
